import { useDeepCompareMemo } from "@react-hookz/web";

import { useEnabledPaymentMethods } from "checkout-experience/hooks/use-enabled-payment-methods";
import { PaymentType } from "checkout-query-client/types/form-types";

import { useEnabledSavedPaymentMethods } from "./use-enabled-saved-payment-methods";

export const usePaymentOption = () => {
  const enabledSavedMOPs = useEnabledSavedPaymentMethods();
  const { activePaymentMethodsList } = useEnabledPaymentMethods();

  return useDeepCompareMemo(() => {
    if (enabledSavedMOPs?.length) {
      return {
        formId: enabledSavedMOPs[0].paymentMethodId,
        paymentType:
          enabledSavedMOPs[0].paymentMethod.case === "card"
            ? PaymentType.creditCard
            : enabledSavedMOPs[0].paymentMethod.case === "electronicCheck"
              ? PaymentType.eCheck
              : PaymentType.sepa,
      };
    } else if (activePaymentMethodsList?.length) {
      return {
        formId: activePaymentMethodsList[0].name,
        paymentType: activePaymentMethodsList[0].name,
      };
    }
    return;
  }, [enabledSavedMOPs, activePaymentMethodsList]);
};
